export default function initKeyboardNav() {
  var menuItems = document.querySelectorAll(
    ".primary-nav .menu-item-has-children"
  );

  menuItems.forEach(function (menuItem) {
    var link = menuItem.querySelector("a");
    var submenu = menuItem.querySelector(".sub-menu");

    // Add event listeners for focus and blur events
    link.addEventListener("focus", function () {
      openSubmenu(menuItem);
    });

    link.addEventListener("blur", function (event) {
      if (!submenu.contains(event.relatedTarget)) {
        closeSubmenu(menuItem);
      }
    });

    // Add event listener for keydown events
    link.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        toggleSubmenu(menuItem);
      }
    });

    // Ensure the submenu stays open when focusing within it
    submenu.addEventListener("focusin", function () {
      openSubmenu(menuItem);
    });

    submenu.addEventListener("focusout", function (event) {
      if (!submenu.contains(event.relatedTarget)) {
        closeSubmenu(menuItem);
      }
    });
  });

  function openSubmenu(menuItem) {
    var submenu = menuItem.querySelector(".sub-menu");
    if (submenu) {
      submenu.style.opacity = "1";
      submenu.style.visibility = "visible";
      menuItem.querySelector("a").setAttribute("aria-expanded", "true");
    }
  }

  function closeSubmenu(menuItem) {
    var submenu = menuItem.querySelector(".sub-menu");
    if (submenu) {
      submenu.style.opacity = "0";
      submenu.style.visibility = "hidden";
      menuItem.querySelector("a").setAttribute("aria-expanded", "false");
    }
  }

  function toggleSubmenu(menuItem) {
    var submenu = menuItem.querySelector(".sub-menu");
    if (submenu) {
      if (submenu.style.opacity === "1") {
        closeSubmenu(menuItem);
      } else {
        openSubmenu(menuItem);
      }
    }
  }
}
